import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { API_URL } from "../../Constants";

const PrivateRoutesJWT = () => {
  const location = useLocation();
  const localStorageToken = localStorage.getItem("token");
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      if (!localStorageToken) {
        setIsValid(false);
        return;
      }

      try {
        const response = await axios.get(
          `${API_URL}/api/ApplicantView/Validate`,
          {
            headers: {
              Authorization: `Bearer ${localStorageToken}`,
            },
          }
        );
        setIsValid(response.status === 200);
      } catch (error) {
        console.error("Token validation failed:", error);
        localStorage.removeItem("token");
        setIsValid(false);
      }
    };

    validateToken();
  }, [localStorageToken, location]);

  if (!isValid) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default PrivateRoutesJWT;
